import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { goNext } from '../../../store/reducers/progressReducer'

import closeImg from '/png/close.png'
import closeGif from '/gif/close.gif'

import './End.scss'

export default function End({ currentIndex, mode, items }) {
  const dispatch = useDispatch()

  const [isButtonHovered, setIsButtonHovered] = useState(false)
  const [isEndVisible, setIsEndVisible] = useState(true)

  function onContinueClick() {
    setIsEndVisible(false)
    dispatch(goNext())
  }

  return (
    <>
      <div
        className={`c-end ${
          currentIndex === items.length && mode === 'free' && isEndVisible
            ? '-is-visible'
            : ''
        }`}
      >
        <h2 className="c-end__title">Félicitations</h2>
        <p className="c-end__message">
          Vous avez reconstitué le message de la carte postale en ravivant un à
          un les souvenirs du foyer. Hestia vous remercie du fond du cœur. Que
          diriez-vous de profiter un peu de la maison, maintenant ?
        </p>
        <div className="c-end__wrapper-credits">
          <div className="c-end__credits">
            <h3 className="c-end__label">Réalisé par</h3>
            <ul className="c-end__list">
              <li>Amandine Quellec</li>
              <li>Éloïse Isautier</li>
              <li>Luana Doeur</li>
              <li>Victor Cango</li>
            </ul>
          </div>
          <div className="c-end__credits">
            <h3 className="c-end__label">Remerciements</h3>
            <ul className="c-end__list">
              <li>Emie Pasquier</li>
              <li>Margaux</li>
              <li>Adrien</li>
            </ul>
          </div>
        </div>

        <button
          className="c-end__close"
          onClick={() => onContinueClick()}
          onPointerEnter={() => setIsButtonHovered(true)}
          onPointerLeave={() => setIsButtonHovered(false)}
        >
          <img src={isButtonHovered ? closeGif : closeImg} />
        </button>
      </div>
    </>
  )
}
